import http from '@/service/http'

const fetch = async ({ commit }, params) => {
  console.log('params: ', params)
  const response = await http.get(`/astropay/cards?page=${params.page}&filter=${params.filter}&value=${params.value}&sort=${params.sort}`)
  if (response !== null) {
    const cards = response.data
    commit('SET_LIST', cards)
  }
}

const fetchByCode = async ({ commit }, code) => {
  try {
    const response = await http.get(`/astropay/${code}`)
    if (response !== null && response.data !== undefined) {
      const card = response.data
      if (card.data !== undefined) {
        commit('SET_CARD', card.data)
      }
    }
  } catch (error) {
    console.log('__ERROR__' + error)
  }
}

const createByCode = async ({ commit }, code) => {
  try {
    const response = await http.post(`/astropay/${code}/create`, {})
    if (response !== null && response.data !== undefined) {
      const card = response.data
      if (card.data !== undefined) {
        return Promise.resolve(true)
      }
    }
  } catch (error) {
    console.log('__ERROR__' + error)
  }
  return Promise.resolve(false)
}

export default {
  fetch,
  fetchByCode,
  createByCode
}



// WEBPACK FOOTER //
// ./src/features/admin/astroPay/store/actions.js